import vTable from "./v-table.vue";
import vRow from "./v-row.vue";
import vCell from "./v-cell.vue";

export default Vue => {
  Vue.component("v-table", vTable);
  Vue.component("v-row", vRow);
  Vue.component("v-cell", vCell);
};
